import React from 'react';
import Social from '../Images/Social.png';
import * as FaIcons from "react-icons/fa";

export default function SocialMedia() {

    return (
        <section className='grid grid-cols-1 lg:grid-cols-2 px-5 py-[10px] md:py-[30px] md:px-20'>
            <div className='mr-auto order-2 lg:order-1'>
                <img src={Social} className="p-16 md:p-0 md:h-96" alt='Social'/>
            </div>
            <div className='space-y-6 order-1 lg:order-2'>
                <div className='text-[8vw] text-center md:text-[7vw] font-bold lg:text-7xl'>
                    Follow us on our social media accounts
                </div>
                <div className='flex justify-center'>
                <a href="https://www.facebook.com/EntrepreneurshipStudentsSociety">
                    <FaIcons.FaFacebook className="mr-3 hover:text-[#ed5955] hover:scale-125 transition-all ease-in-out cursor-pointer text-6xl"/>
                </a>
                <a href="https://www.instagram.com/ecss_abouquir/">
                    <FaIcons.FaInstagram className="mr-3 hover:text-[#ed5955] hover:scale-125 transition-all ease-in-out cursor-pointer text-6xl"/>
                </a>
                <a href="mailto:aastsociety@gmail.com">
                    <FaIcons.FaEnvelope className="mr-3 hover:text-[#ed5955] hover:scale-125 transition-all ease-in-out cursor-pointer text-6xl"/>
                </a>
                </div>
            </div>
        </section>
    );
}